import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"surface"},[_c('app-btn',{staticClass:"ma-1",on:{"click":_vm.createSortie}},[_vm._v("New Flight ")]),_c('flight-strip-bay',{attrs:{"loading":_vm.loading,"items":_vm.flightStripBay,"last-updated":_vm.lastUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }